import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { CollaboratorInvitation } from "@models/collaborator";
import { InvitationStatusEnum } from "@models/invitation";
import { Page } from "@models/page";
import { CollaboratorRoleEnumPipe } from "@shared/pipes/collaborator-role-enum.pipe";
import { InvitationStatusEnumPipe } from "@shared/pipes/invitation-status-enum.pipe";
import { PaginatorModule, PaginatorState } from "primeng/paginator";
import { SkeletonModule } from "primeng/skeleton";
import { TableModule } from "primeng/table";

@Component({
  selector: "app-employees-invitations-table",
  imports: [
    TableModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    SkeletonModule,
    PaginatorModule,
    CollaboratorRoleEnumPipe,
    InvitationStatusEnumPipe,
  ],
  templateUrl: "./employees-invitations-table.component.html",
  styleUrl: "./employees-invitations-table.component.scss",
})
export class EmployeesInvitationsTableComponent {
  @Input() data: Page<CollaboratorInvitation> | null = null;
  @Input() readOnly = false;
  first = 0;
  rows = 10;

  @Output() revokeInvitationClick = new EventEmitter<CollaboratorInvitation>();
  @Output() resendInviteClick = new EventEmitter<CollaboratorInvitation>();
  @Output() pageChange = new EventEmitter<PaginatorState>();
  @Output() editPdvPermission = new EventEmitter<CollaboratorInvitation>();

  invtationStatusEnum = InvitationStatusEnum;
}
